module.exports = __webpack_public_path__ + "img/bpjs.b312d4c4.png";